import { useState, useEffect, useRef } from 'react';
import { Marker, Popup, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { LatLngExpression } from 'leaflet';
import { MapRef } from 'react-leaflet/lib/MapContainer';
// import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
// import PersonPinCircleOutlinedIcon from '@mui/icons-material/PersonPinCircleOutlined';
import MyLocationTwoToneIcon from '@mui/icons-material/MyLocationTwoTone';
import { renderToStaticMarkup } from 'react-dom/server'
import { divIcon } from 'leaflet'

export const MapLocationMarker = () => {
  const [position, setPosition] = useState<LatLngExpression | null>(null);
  const map = useMapEvents({
    locationfound(e) {
      setPosition(e.latlng);
    },
    locationerror(e) {
      console.error("Location error:", e.message);
      // TODO: Handle the error appropriately, e.g., display an error message
    }
  });
  const mapRef = useRef<MapRef>(null);

  useEffect(() => {
    mapRef.current = map;
  }, [map]);

  useEffect(() => {
    mapRef.current?.locate({
      watch: true, // Continuously monitor location
      enableHighAccuracy: true,
      maximumAge: 10000,
      timeout: 10000
    });

    // Cleanup function to stop location watching
    return () => {
        mapRef.current?.stopLocate();
    };
  }, []);

  return position === null ? null : (
    <Marker 
      position={position}
      icon={
        divIcon({
          html: renderToStaticMarkup(
            <MyLocationTwoToneIcon />
          ),
          iconSize: [0, 0], 
        })
      }
    >
      <Popup>You are here</Popup>
    </Marker>
  );
};
